// External libraries
import styled from '@emotion/styled';

// Internal modules
import {
  FONT_SIZE_MEDIUM,
  FONT_WEIGHT_NORMAL_PP,
  HIGH_CONTRAST_TEXT_COLOR,
} from '@/styles';

const Legend = styled.legend`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${FONT_SIZE_MEDIUM};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  line-height: 1.33;
  margin-bottom: 1rem;
  margin-top: 0.25rem;
  padding: 0;
  @media (min-width: 22.8rem) {
    font-size: ${FONT_SIZE_MEDIUM};
  }
`;

export { Legend };
